import styled from "styled-components";

const STATUS = {
  OFFLINE: "offline",
  ERROR: "error",
  WAITING: "waiting",
  INSTALLING: "installing",
  DONE: "done",
  ALREADY_INSTALLED: "alreadyInstalled",
};

const statusIconMap = {
  [STATUS.OFFLINE]: "cloud_off",
  [STATUS.ERROR]: "error_outline",
  [STATUS.WAITING]: "sync",
  [STATUS.INSTALLING]: "sync",
  [STATUS.DONE]: "check",
  [STATUS.ALREADY_INSTALLED]: "check",
};

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 20px;

  thead tr {
    height: 30px;
  }

  .bqn-column {
    width: 80px;
    max-width: 80px;
  }

  .icon {
    width: 20px;
    max-width: 20px;
    text-align: center;
    padding-bottom: 3px;

    i {
      font-size: 14px;
    }
  }

  .error-line {
    label,
    i {
      color: red;
    }
  }

  .success-line {
    label,
    i {
      color: green;
    }
  }

  .status {
    font-weight: bold !important;
  }
`;

export function ClusterInstallationStatus({ data }) {
  function getStatusLabel({ status, Name, Version, error }) {
    switch (status) {
      case STATUS.OFFLINE:
        return "Offline";
      case STATUS.WAITING:
        return "Waiting...";
      case STATUS.INSTALLING:
        return "Installing...";
      case STATUS.DONE:
        return `Installed ${Name} ${Version}`;
      case STATUS.ALREADY_INSTALLED:
        return `Package ${Name}-${Version} already installed.`;
      case STATUS.ERROR:
        return `Error: ${error}`;
      default:
        return status;
    }
  }

  return (
    data && (
      <Div className="text-align-left pre-wrap">
        <table>
          <thead>
            <tr>
              <th></th>
              <th className="bqn-column">BQN</th>
              <th>Status</th>
            </tr>
          </thead>
          {Object.values(data).map(
            ({ bqnId, status, Name, Version, error }) => {
              return (
                <tr
                  key={bqnId}
                  className={`${
                    status === STATUS.ERROR ? "error-line" : ""
                  }${status === STATUS.DONE || status === STATUS.ALREADY_INSTALLED ? " success-line" : ""}`}
                >
                  <td className="icon">
                    <i className="material-icons">{statusIconMap[status]}</i>
                  </td>
                  <td>
                    <label>BQN {bqnId} </label>
                  </td>
                  <td>
                    <label className="status">
                      {getStatusLabel({ status, Name, Version, error })}{" "}
                    </label>
                  </td>
                </tr>
              );
            }
          )}
        </table>
      </Div>
    )
  );
}
